(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/betslipv2/views/betslip-header.js') >= 0) return;  svs.modules.push('/components/app/betslipv2/views/betslip-header.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.app=_svs.app||{};
_svs.app.betslipv2=_svs.app.betslipv2||{};
_svs.app.betslipv2.templates=_svs.app.betslipv2.templates||{};
svs.app.betslipv2.templates.betslip_header = Handlebars.template({"0":function(container,depth0,helpers,partials,data) {
    return "betslip-header-syndicate";
},"1":function(container,depth0,helpers,partials,data) {
    return "betslip-header-inner";
},"2":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"left bold\">"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"headerText") || (depth0 != null ? lookupProperty(depth0,"headerText") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"headerText","hash":{},"data":data,"loc":{"start":{"line":2,"column":45},"end":{"line":2,"column":59}}}) : helper)))
    + "</div>";
},"3":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <span class=\"left f-left betslip-header-syndicate-info\">\n        Du spelar för laget <br />\n        <span class=\"f-bold f-uppercase\">'"
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"syndicateName") || (depth0 != null ? lookupProperty(depth0,"syndicateName") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"syndicateName","hash":{},"data":data,"loc":{"start":{"line":6,"column":42},"end":{"line":6,"column":59}}}) : helper)))
    + "'</span>.\n    </span>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\""
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"isSyndicate") : depth0),{"name":"if","hash":{},"fn":container.program(0, data, 0),"inverse":container.program(1, data, 0),"data":data,"loc":{"start":{"line":1,"column":12},"end":{"line":1,"column":90}}})) != null ? stack1 : "")
    + "\">\n    "
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"headerText") : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":2,"column":72}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"isSyndicate") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":4},"end":{"line":8,"column":11}}})) != null ? stack1 : "")
    + "    <span class=\"close-label\">Stäng</span>\n    <i class=\"icon-default icon-100 icon-menu-down betslip-icon grey-500 f-800 right\"></i>\n</div>";
},"useData":true});
Handlebars.partials['components-app-betslipv2-betslip_header'] = svs.app.betslipv2.templates.betslip_header;
})(svs, Handlebars);


 })(window);